"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexiBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _recharts = require("recharts");
var _theme = require("../theme");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var FlexiWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n"])));
var shader = function shader(col) {
  var shader = [];
  for (var w = 0; w < 5; w++) {
    shader.push((0, _polished.transparentize)(w * 0.2, col));
  }
  return shader;
};
var CandyBar = function CandyBar(props) {
  var oX = props.x,
    oY = props.y,
    oWidth = props.width,
    oHeight = props.height,
    value = props.value,
    fill = props.fill,
    type = props.type;
  var selectedType = type.length >= 6 ? type : 'stripe';
  var x = oX;
  var y = oHeight < 0 ? oY + oHeight : oY;
  var width = oWidth;
  var height = Math.abs(oHeight);
  return /*#__PURE__*/_react["default"].createElement("rect", {
    fill: fill,
    mask: "url(#".concat(selectedType, ")"),
    x: x,
    y: y,
    width: width,
    height: height
  });
};
var FlexiBar = exports.FlexiBar = function FlexiBar(props) {
  var data;
  if (props.data) {
    data = props.data;
  } else {
    data = props.yData.map(function (elem, id) {
      return _objectSpread({
        name: props.xData[id]
      }, elem);
    });
  }
  var i = -1;
  var colors = props.shade ? typeof props.shade === 'string' ? shader(props.shade) : shader(_theme.FlexTheme.PrimaryColor) : props.colors;
  var shapes = props.shapes;
  var myStacks = [];
  if (props.stackSelected) {
    myStacks = !Array.isArray(props.stackSelected) ? [props.stackSelected] : props.stackSelected;
  }
  return /*#__PURE__*/_react["default"].createElement(FlexiWrapper, null, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    aspect: props.aspect && 3,
    height: props.aspect ? false : props.height
  }, /*#__PURE__*/_react["default"].createElement(_recharts.BarChart, _extends({
    data: data
  }, props), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe",
    width: "3",
    height: "3",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "1",
    height: "3",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "stripe"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe)"
  })), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe2",
    width: "3",
    height: "3",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(-45)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "1",
    height: "3",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "stripeReverse"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe2)"
  })), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe3",
    width: "5",
    height: "5",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "2",
    height: "2",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "stared"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe3)"
  })), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe6",
    width: "3",
    height: "3",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(0)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "1",
    height: "3",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "dashed"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe6)"
  })), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe4",
    width: "6",
    height: "6",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "5",
    height: "10",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "stripeThick"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe4)"
  })), /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-stripe5",
    width: "6",
    height: "6",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(-45)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "5",
    height: "10",
    transform: "translate(0,0)",
    fill: "white"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "stripeReverseThick"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: "url(#pattern-stripe5)"
  })), props.tooltip && (props.tooltip === "light" ? /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    formatter: function formatter(value) {
      return value && value.toLocaleString();
    },
    contentStyle: {
      background: "rgba(255,255,255,0.9)",
      borderRadius: "3px",
      border: "none",
      padding: "15px",
      boxShadow: "1px 2px 10px rgba(0,0,0,0.2)"
    },
    itemStyle: {
      color: "#333"
    },
    cursor: {
      opacity: 0.05,
      fill: "rgba(0,0,0,0.9)"
    },
    allowEscapeViewBox: {
      x: false,
      y: true
    }
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    formatter: function formatter(value) {
      return value && value.toLocaleString();
    },
    contentStyle: {
      background: "rgba(32,39,46,0.9)",
      borderRadius: "3px",
      border: "none",
      padding: "15px",
      boxShadow: "1px 2px 10px rgba(0,0,0,0.2)"
    },
    itemStyle: {
      color: "#fff"
    },
    cursor: {
      opacity: 0.05,
      fill: "rgba(0,0,0,0.9)"
    },
    allowEscapeViewBox: {
      x: false,
      y: true
    }
  })), props.grid && /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: typeof props.grid === "string" ? "".concat(props.grid, " ").concat(props.grid) : "3 3"
  }), props.children, Object.keys(data[0]).map(function (key, index) {
    if (key != "name" && key != "fill") {
      i++;
      var stackedGroup = "stack-".concat(key);
      props.stackSelected && myStacks.map(function (exlem, indexer) {
        stackedGroup = exlem.includes(key) ? "stack-".concat(indexer) : stackedGroup;
        return null;
      });
      return /*#__PURE__*/_react["default"].createElement(_recharts.Bar, _extends({
        key: "data-".concat(key, "-").concat(index),
        dataKey: key
      }, props.barProperties, {
        shape: shapes[i] ? /*#__PURE__*/_react["default"].createElement(CandyBar, {
          type: shapes[i],
          fill: colors[i]
        }) : null,
        fill: colors[i],
        stackId: props.stack ? "stack-0" : props.stackSelected && stackedGroup
      }));
    } else {
      return null;
    }
  }), props.yAxis && /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, {
    allowDecimals: props.allowDecimals ? props.allowDecimals : false,
    stroke: (0, _polished.darken)(0.2, _theme.FlexTheme.PrimaryBorderColor)
  }, props.yLabel && /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
    value: props.yLabel,
    position: "insideLeft",
    angle: -90
  })), props.xAxis && /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
    allowDecimals: props.allowDecimals ? props.allowDecimals : false,
    dataKey: "name",
    stroke: (0, _polished.darken)(0.2, _theme.FlexTheme.PrimaryBorderColor)
  }, props.xLabel && /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
    value: props.xLabel,
    offset: 0,
    position: "insideBottom"
  })), props.legend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
    align: "right",
    verticalAlign: "top",
    wrapperStyle: {
      top: "-20px"
    }
  }))));
};
FlexiBar.defaultProps = {
  height: 200,
  shapes: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
  colors: [_theme.FlexTheme.PrimaryColor, _theme.FlexTheme.PrimaryRed, _theme.FlexTheme.PrimaryOrange, _theme.FlexTheme.PrimaryYellow, _theme.FlexTheme.PrimaryGreen, _theme.FlexTheme.PrimaryBlue, _theme.FlexTheme.PrimaryGrey, _theme.FlexTheme.PrimaryGreyLight, _theme.FlexTheme.SecondaryColor],
  allowDecimals: false
};
FlexiBar.propTypes = {
  height: _propTypes["default"].number,
  colors: _propTypes["default"].array,
  shade: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  grid: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  xData: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  yData: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  stack: _propTypes["default"].bool,
  yAxis: _propTypes["default"].bool,
  xAxis: _propTypes["default"].bool,
  legend: _propTypes["default"].bool,
  xLabel: _propTypes["default"].string,
  yLabel: _propTypes["default"].string,
  barProperties: _propTypes["default"].array,
  tooltip: _propTypes["default"].oneOf(['light', false, true, null]),
  shapes: _propTypes["default"].array,
  allowDecimals: _propTypes["default"].bool
};